import React, {Component} from "react";
import SimpleUploadImage from "../../../modules/upload/SimpleUploadImage";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleTextArea from "../../../modules/simpleTextArea";
import FlexView from "react-flexview";

class CustomerProfileCDBModifyingInputHeader extends Component {
    render() {
        return (
            <>
                <div className="grid grid-3x gap-20px grid-mobile-none paddingTop-20px">
                    <div id="grid-1">
                        <SimpleUploadImage
                            id="input_upload_foto_wajah"
                            name="fotoProfilBase64"
                            shape="circle"
                            label="Foto Wajah"
                            value={this.props.data?.fotoProfilBase64}
                            onChange={(value, name) => this.props.onValueChange(name, value)}
                        />
                    </div>
                    <div id="grid-2">
                        <div className="margin-10px">
                            <div className="txt-site txt-16 txt-main txt-bold">
                                <h4>Data Customer</h4>
                            </div>
                        </div>
                        <SimpleInput
                            id="input_text_nama_customer"
                            name="customerName"
                            label="Nama Customer"
                            readOnly
                            value={this.props.data?.dataCustomer?.customerName}
                        />
                        <SimpleInput
                            id="input_text_nik"
                            name="nik"
                            label="NIK"
                            readOnly
                            value={this.props.data?.dataCustomer?.nik}
                        />
                        <SimpleTextArea
                            id="input_text_alamat"
                            typeInputCase="normal"
                            name="address"
                            label="Alamat"
                            readOnly
                            value={this.props.data?.dataCustomer?.address}
                        />
                        <SimpleInput
                            id="input_text_provinsi"
                            name="provinceName"
                            label="Provinsi"
                            readOnly
                            value={this.props.data?.dataCustomer?.dataProvince?.provinceName}
                        />
                        <SimpleInput
                            id="input_text_kab_kota"
                            name="kabkotName"
                            label="Kab Kota"
                            readOnly
                            value={this.props.data?.dataCustomer?.dataKabKot?.kabKotName}
                        />
                        <SimpleInput
                            id="input_text_kecamatan"
                            name="kecamatanName"
                            label="Kecamatan"
                            readOnly
                            value={this.props.data?.dataCustomer?.dataKecamatan?.kecamatanName}
                        />
                        <SimpleInput
                            id="input_text_pekerjaan_1"
                            name="pekerjaan1"
                            label="Pekerjaan 1"
                            readOnly
                            value={this.props.data?.dataCustomer?.pekerjaan1?.value}
                        />
                        <SimpleInput
                            id="input_text_pekerjaan_2"
                            name="pekerjaan2"
                            label="Pekerjaan 2"
                            readOnly
                            value={this.props.data?.dataCustomer?.pekerjaan2?.value}
                        />
                        <SimpleInput
                            id="input_text_agama"
                            name="agama"
                            label="Agama"
                            readOnly
                            value={this.props.data?.dataCustomer?.dataAgama?.value}
                        />
                    </div>
                    <div id="grid-3">
                        <FlexView column style={{gap: 20}}>
                            <FlexView column>
                                <div className="margin-10px">
                                    <div className="txt-site txt-16 txt-main txt-bold">
                                        <h4>Data Tambahan</h4>
                                    </div>
                                </div>
                                <SimpleInput
                                    id="input_text_no_hp_1"
                                    name="nomorHP1"
                                    label="No HP 1"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.nomorHP1}
                                />
                                <SimpleInput
                                    id="input_text_no_hp_2"
                                    name="nomorHP2"
                                    label="No HP 2"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.nomorHP2}
                                />
                                <SimpleInput
                                    id="input_text_instagram_acc"
                                    name="instagramAccount"
                                    label="Instagram Acc"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.instagramAccount}
                                />
                                <SimpleInput
                                    id="input_text_facebook_acc"
                                    name="facebookAccount"
                                    label="Facebook Acc"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.facebookAccount}
                                />
                                <SimpleInput
                                    id="input_text_x_acc"
                                    name="xAccount"
                                    label="X Acc"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.xAccount}
                                />
                                <SimpleInput
                                    id="input_text_tiktok_acc"
                                    name="tiktokAccount"
                                    label="Tiktok Acc"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.tiktokAccount}
                                />
                                <SimpleInput
                                    id="input_text_disc"
                                    name="disc"
                                    label="DISC"
                                    readOnly
                                    value={this.props.data?.dataTambahan?.disc}
                                />
                            </FlexView>
                            <FlexView column>
                                <div className="margin-10px">
                                    <div className="txt-site txt-16 txt-main txt-bold">
                                        <h4>Data Member</h4>
                                    </div>
                                </div>
                                <SimpleInput
                                    id="input_text_kode_member"
                                    name="kodeMember"
                                    label="Kode Member"
                                    readOnly
                                    value={this.props.data?.dataMember?.kodeMember}
                                />
                                <SimpleInput
                                    id="input_text_member_level"
                                    name="memberLevel"
                                    label="Member Level"
                                    readOnly
                                    value={this.props.data?.dataMember?.memberLevel}
                                />
                                <SimpleInput
                                    id="input_text_loyalty_level"
                                    name="loyaltyLevel"
                                    label="Loyalty Level"
                                    readOnly
                                    value={this.props.data?.dataMember?.loyaltyLevel}
                                />
                                <SimpleInput
                                    id="input_text_lategori_khusus"
                                    name="kategoriKhusus"
                                    label="Kategori Khusus"
                                    readOnly
                                    value={this.props.data?.dataMember?.kategoriKhusus}
                                />
                                <SimpleInput
                                    id="input_text_total_point"
                                    name="totalPoint"
                                    label="Total Point"
                                    readOnly
                                    value={this.props.data?.dataMember?.totalPoint}
                                />
                            </FlexView>
                        </FlexView>
                    </div>
                </div>
            </>
        )
    }
}

export default CustomerProfileCDBModifyingInputHeader;